// Brand logo tile — always white background, rounded corners, proper aspect.
import { useState } from "react";

export default function BrandTile({ text, sub, image }) {
  const [error, setError] = useState(false);
  return (
    <div className="h-28 w-56 sm:w-64 bg-white border border-slate-200 rounded-2xl flex flex-col items-center justify-center px-5 py-4 hover:border-[#1E3A8A] hover:shadow-md transition-all duration-300">
      {image && !error ? (
        <img
          src={image}
          alt={text}
          onError={() => setError(true)}
          className="max-h-16 max-w-full object-contain"
          loading="lazy"
        />
      ) : (
        <>
          <div className="font-display font-extrabold text-lg sm:text-xl tracking-tight text-slate-800 text-center">
            {text}
          </div>
          {sub && (
            <div className="mt-1 text-[10px] uppercase tracking-widest text-slate-500 text-center">
              {sub}
            </div>
          )}
        </>
      )}
    </div>
  );
}
